import { useLocation, Navigate } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "@/hooks/use-auth";

const AuthGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/" state={{ redirectPath: location.pathname }} />
  );
};

export default AuthGuard;
